import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["panel", "overlay"]
    
    static selectors = {
        EDIT_BUTTON: 'editProfileBtn',
        CLOSE_BUTTON: 'closeEditBtn',
        CANCEL_BUTTON: 'cancel-edit',
        OVERLAY: 'overlay',
        PROFILE_FORM: 'edit-profile-form',
        FIRST_NAME_INPUT: '#id_first_name',
        LAST_NAME_INPUT: '#id_last_name'
    }
    
    static NAME_FILTER_REGEX = /[^a-zA-Z\s'-]/g

    connect() {
        const { selectors } = this.constructor
        const editBtn = document.getElementById(selectors.EDIT_BUTTON)
        const closeBtn = document.getElementById(selectors.CLOSE_BUTTON)
        const cancelBtn = document.getElementById(selectors.CANCEL_BUTTON)
        const overlay = document.getElementById(selectors.OVERLAY)
        const profileForm = document.getElementById(selectors.PROFILE_FORM)
        
        this.profileForm = profileForm
        
        editBtn.addEventListener('click', this.open.bind(this))
        closeBtn.addEventListener('click', this.close.bind(this))
        cancelBtn.addEventListener('click', this.close.bind(this))
        overlay.addEventListener('click', this.close.bind(this))
        profileForm.addEventListener('submit', this.handleProfileSubmit.bind(this))
        
        this.firstNameInput = profileForm.querySelector(selectors.FIRST_NAME_INPUT)
        this.lastNameInput = profileForm.querySelector(selectors.LAST_NAME_INPUT)
        this.firstNameError = document.querySelector('.frontend-validation-error-first-name')
        this.lastNameError = document.querySelector('.frontend-validation-error-last-name')
        this.firstNameErrorMessage = this.firstNameError.querySelector('.frontend-validation-error-message')
        this.lastNameErrorMessage = this.lastNameError.querySelector('.frontend-validation-error-message')
        
        this.firstNameInput.addEventListener('input', () => this.handleNameInput(this.firstNameInput, this.firstNameError))
        this.lastNameInput.addEventListener('input', () => this.handleNameInput(this.lastNameInput, this.lastNameError))
    }

    toggleBackToTop(hide) {
        const backToTopContainer = document.getElementById('back-to-top-container')
        if (backToTopContainer) {
            backToTopContainer.classList.toggle('hidden', hide)
        }
    }

    handleNameInput(inputElement, errorElement) {
        inputElement.value = inputElement.value.replace(this.constructor.NAME_FILTER_REGEX, '')
        errorElement.classList.add('hidden')
    }
    
    closeSearchBar() {
        const navigationController = this.application.getControllerForElementAndIdentifier(
            document.querySelector('[data-controller="navigation"]'),
            "navigation"
        )
        
        if (navigationController && navigationController.hasSearchBarTarget) {
            const searchBar = navigationController.searchBarTarget
            
            if (searchBar && searchBar.style.display !== 'none') {
                navigationController.toggleSearchBar()
            }
        }
    }

    open(event) {
        event?.preventDefault()
        this.closeSearchBar()
        this.panelTarget.style.right = '0'
        this.overlayTarget.classList.remove('hidden')
        document.body.style.overflow = 'hidden'
        this.toggleBackToTop(true)
    }

    close(event) {
        event?.preventDefault()

        this.panelTarget.style.right = '-100%'
        this.overlayTarget.classList.add('hidden')
        document.body.style.overflow = ''
        this.toggleBackToTop(false)
        this.resetForm()
    }

    resetForm() {
        this.profileForm?.reset()
        const selectEl = this.profileForm?.querySelector('[data-controller~="select"]')
        const selectController = selectEl && this.application.getControllerForElementAndIdentifier(selectEl, 'select')
        selectController?.updateSelectedText?.()
        this.firstNameError?.classList.add('hidden')
        this.lastNameError?.classList.add('hidden')
    }

    handleProfileSubmit(event) {
        const firstName = this.firstNameInput.value.trim()
        const lastName = this.lastNameInput.value.trim()
        
        this.firstNameError.classList.add('hidden')
        this.lastNameError.classList.add('hidden')
        
        let hasErrors = false
        
        if (!firstName) {
            this.firstNameErrorMessage.textContent = 'This field is required.'
            this.firstNameError.classList.remove('hidden')
            hasErrors = true
        }
        
        if (!lastName) {
            this.lastNameErrorMessage.textContent = 'This field is required.'
            this.lastNameError.classList.remove('hidden')
            hasErrors = true
        }
        
        if (hasErrors) {
            event.preventDefault()
            event.stopPropagation()
            return false
        }
    }
}